import {Widget} from "base/assets/js/widget/Widget.js";
import {Comm} from "base/assets/js/widget/Comm.js";
import {Comms} from "base/assets/js/widget/Comms.js";

/**
 * направляющие комментариев ( указание вложенности ), по событию scroll меняет ширину направляющих,
 * чтобы большая вложенность отображалась адекватно
 */
export class CWays extends Widget {

	_aActiveLevs = [];
	_iMaxActive;
	_aComms;
	_bNext = false;
	_bFirst = true;
	_iAnimate = 1;
	_bTicking = false;
	_bSkipScroll = false;
	_iNeedLev = null;

	run() {

		this._my( { 'max-active': 'i:_iMaxActive' } );

		this._on( 'Item[]?', 'click', ( oEvent ) => {
			const oComm = this._findCommByClickEvent( oEvent );
			if( oComm ) {
				// находим комментарий предок
				const iForLev = this._attr( oEvent.currentTarget, 'i:for-lev' ) - 1;
				oComm.scrollToParent( iForLev, true );
			}
		} );

		this._fnScrollHandler = () => {
			if( this._bSkipScroll ) {
				return;
			}

			// https://developer.mozilla.org/en-US/docs/Web/API/Document/scroll_event
			if( window.requestAnimationFrame ) {
				if ( !this._bTicking ) {
					window.requestAnimationFrame( () => {
						this.timeoutHandler();
						this._bTicking = false;
					} );
					this._bTicking = true;
				}
			} else {
				this.timeoutHandler();
			}
		}
		this.attach();
		this.timeoutHandler( 100 );
	}

	attach() {
		this._on( window, 'scroll', this._fnScrollHandler );
	}

	detach() {
		this._off( window, 'scroll', this._fnScrollHandler );
	}

	destructor() {
		super.destructor();
		this.detach();
	}

	skipScroll( bValue ) {
		this._bSkipScroll = bValue;
	}

	/**
	 * добавить направляющих, если их не достаточно
	 * @param iMaxLevel
	 */
	setMaxLevel( iMaxLevel ) {
		while( this._el( 'Item[]?' ).length < iMaxLevel - 1 ) {
			let aItems = this._el( 'Item[]?' );
			let eNewItem = document.createElement( 'div' );
			eNewItem.className = 'cway _CWays-Item';
			eNewItem.setAttribute( 'data-for-lev', aItems.length + 2 );
			if( aItems.length ) {
				aItems[aItems.length - 1].insertAdjacentElement( 'afterend', eNewItem );
			} else {
				// ситуация, когда этот элемент первый
				this._el( 'Items' ).insertAdjacentElement( 'afterbegin', eNewItem )
			}
			this._elReset();
		}
	}

	timeoutHandler( iDelay = 2000 ) {
		if( !this.pPrev ) {
			this.pPrev = new Promise( ( fnResolve ) => {
				setTimeout(
					() => {
						this.scrollHandler().then( () => {
							this.pPrev = null;
							fnResolve();
						} );
					},
					iDelay
				);
			} );
		} else if( !this._bNext ) {
			this._bNext = true;
			this.pPrev.then( () => {
				this._bNext = false;
				this.timeoutHandler( 0 );
			} )
		}
	}

	scrollHandler() {
		const iFrom = window.innerHeight / 4;
		const iTo = window.innerHeight * 3 /4;
		let i, aComms = [], oComm, oOffset;
		this._aComms = this._getComms().getItems();

		if( this._aComms.length === 0 ) {
			// если пока все пусто, то перебирать комментарии нет смысла
			this.refresh( aComms );
		}
		for( i = 0; (oComm = this._aComms[ i ]); i++ ) {

			if( oComm.isHide() ) {
				continue;
			}

			try {
				oOffset = oComm.bl().getBoundingClientRect();
			} catch( e ) {
				return;
			}
			if ( oOffset.top > iFrom && oOffset.top < iTo ) {
				aComms.push( oComm );
			}
			if( oOffset.top > iTo ) {
				// нет смысла дальше общитывать, и так за пределами будет

				// если ничего не нашли, просто берем его
				if( !aComms.length ) {
					aComms.push( oComm );
				}

				break;
			}
		}
		return this.refresh( aComms );
	}

	/**
	 * @param oEvent
	 * @return {false|Comm}
	 */
	_findCommByClickEvent( oEvent ) {
		let i, oComm, oOffset;
		this._aComms = this._getComms().getItems();

		if( this._aComms.length === 0 ) {
			return false;
		}
		for( i = 0; (oComm = this._aComms[ i ]); i++ ) {

			try {
				oOffset = oComm.bl().getBoundingClientRect();
			} catch( e ) {
				return null;
			}
			if ( oOffset.top < oEvent.clientY && oOffset.bottom > oEvent.clientY ) {
				return oComm;
			}
		}
		return null;
	}

	refresh( aComms, iNeedLev = null ) {

		if( iNeedLev ) {
			// дополнительный уровень, для написания нового комментария
			this._iNeedLev = iNeedLev;
		}

		this._findLevs( aComms );

		// просто заполним массив активныых 1 .. iMaxLev значениями
		let iLev = 2;
		const iNeed = Math.min( this._iMaxActive, this._el( 'Item[]?' ).length );
		while( this._aActiveLevs.length < iNeed ) {
			this._addLev( iLev )
			iLev++;
		}

		this._el( 'Item[]?' ).forEach( ( eGuide, iIndex ) => {
			let iLev = iIndex + 2;
			let bActive = this._aActiveLevs.indexOf( iLev ) !== -1;
			this._mod( eGuide, 'cway_wide', bActive );
		} );

		// обновляем отступы
		return this._refreshOffsets();
	}

	/**
	 * среди массива Comm[] найти активные уровни вложенности
	 * @param aComms
	 */
	_findLevs( aComms ) {
		this._aActiveLevs = [];

		if( this._iNeedLev ) {
			this._addLev( this._iNeedLev );
		}

		if( aComms.length === 0 ) {
			return;
		}

		let iMaxDelta = 100;
		let oCommPrev, oCommNext;
		let iLen = aComms.length;
		for( let i = 0; i < iLen; i++ ) {
			let oComm = aComms[ i ];
			if( i === 0 ) {
				oCommPrev = oComm;
			}
			if( i === iLen - 1 ) {
				oCommNext = oComm;
			}
			this._addLev( oComm.getLev() );
			if ( this._aActiveLevs.length >= this._iMaxActive ) {
				break;
			}
		}

		for( let i = 0; i < iMaxDelta; i++ ) {
			// мутное выражение, вверх идем наполовину, вниз по полной
			if( oCommPrev ) {
				if( !oCommPrev.isHide() ) {
					this._addLev( oCommPrev.getLev() )
				}
				let iPrevIndex = this._aComms.indexOf( oCommPrev );
				oCommPrev = null;
				if( iPrevIndex > 0 ) {
					oCommPrev = this._aComms[ iPrevIndex - 1 ];
				}

			}
			if( oCommNext ) {
				if( !oCommNext.isHide() ) {
					this._addLev( oCommNext.getLev() );
				}
				let iNextIndex = this._aComms.indexOf( oCommNext );
				oCommNext = null;
				if( iNextIndex < this._aComms.length - 1 ) {
					oCommNext = this._aComms[ iNextIndex + 1 ]
				}
			}
			if ( this._aActiveLevs.length >= this._iMaxActive ) {
				break;
			}
		}
		//console.log( this._aActiveLevs );
	}

	_addLev( iLev ) {
		if( iLev < 2 ) {
			return;
		}
		if( this._aActiveLevs.indexOf( iLev ) === -1 ) {
			this._aActiveLevs.push( iLev );
		}

		// добавим предыдущий, так выглядит лучше
		if( iLev > 3 ) {
			let iPrevLev = iLev - 1;
			if( this._aActiveLevs.indexOf( iPrevLev ) === -1 ) {
				this._aActiveLevs.push( iPrevLev );
			}
		}
	}

	_refreshOffsets() {

		// изменяем ширины направляющих
		const iAllCnt = this._el( 'Item[]?' ).length;
		const iActiveCnt = this._aActiveLevs.length;
		const iCnt = iAllCnt - iActiveCnt;
		const iWidthAll = 100;
		let fWidthWay, fWidthWayWide;
		if( iCnt ) {
			fWidthWay = ( iWidthAll * 0.2 ) / iCnt;
			fWidthWayWide = ( iWidthAll * 0.8 ) / iActiveCnt;
		} else {
			fWidthWay = 0;
			fWidthWayWide = iWidthAll / iActiveCnt;
		}
		this._el( 'Body' ).style.setProperty('--width-way', fWidthWay + '%' );
		this._el( 'Body' ).style.setProperty('--width-way-wide', fWidthWayWide + '%' );

		let aGuideWidths = [];

		this._el( 'Item[]?' ).forEach( ( eGuide, iIndex ) => {
			aGuideWidths[ iIndex ] = eGuide.getBoundingClientRect().width;
		} );

		this._mod( '', 'comms_an_paused', true );

		let fOffset = 0;
		for( let iLev = aGuideWidths.length + 1; iLev > 0; iLev-- ) {
			// 0.5 поправка, на преобразование процентов, без нее появляются артефакты
			this._el( 'Body' ).style.setProperty('--comm-way1-' + iLev, -fOffset - 0.5 + 'px' );
			fOffset += aGuideWidths[ iLev - 2 ];
		}

		this._mod( '', 'comms_an_paused', false );

		// вся анимация длится не более 1 секунды, по css правилам
		return new Promise( ( fnResolve ) => {
			setTimeout(
				() => {
					if( this._bFirst ) {
						this._bFirst = false;
						this._mod( '', 'comms_an', true );
					}
					fnResolve();
				},
				1000
			);
		} );
	}

	/**
	 * @return {Comms}
	 */
	_getComms() {
		if( !this._oComms ) {
			this._oComms = this._rel().parent().typeOf(Comms).find();
		}
		return this._oComms;
	}
}